var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"padding-top-65",attrs:{"tile":"","outlined":"","elevation":"0"}},[_c('div',{staticClass:"map",style:({height: _vm.getViewportHeight, width: _vm.getViewportWidth}),attrs:{"id":"title-heatmap"},on:{"set-gradient":_vm.setGradient}})])
}
var staticRenderFns = []

export { render, staticRenderFns }